import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom'
import {mostrarPrestamos} from "../../redux/reducers/prestamosReducer";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TableBody,
    TableCell,
    TableFooter,
    TableRow,
    TextField,
    Theme,
    Typography,
    useMediaQuery
} from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import {
    AppBar,
    ButtonResponsive,
    FilteredAlert,
    ListViewMode,
    LoadingProgress,
    MostrarError,
    Pagination,
    PlusFab,
    SeacrhAppBar,
    TableSort
} from "../../components";
import {SelectAgente, SelectCaja, SelectCartera, SelectEnum, SelectRuta} from "../../components/selects";

import {formatDate, formatPeso, hasPermissionTo, PERSMISOS, translateText} from "../../helpers";
import Strings from '../../assets/strings'

import ItemPrestamo from "../../components/CustomListItem/itemPrestamo";
import downloadFiles from "../../helpers/downloadFiles";
import ButtonSelect from "../../components/ButtonSelect";
import {CloudDownloadOutlined, FilterList} from "@mui/icons-material";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPrestamoFilter} from "../../redux/types/IPrestamo";
import {ESTADO_PRESTAMO, getValueString, SITUACION_PRESTAMO} from '../../helpers/CONSTANTES';
import {ICliente} from "../../redux/types/ICliente";
import estadoPrestamo from "../../styles/estadoPrestamo";
import TopBarDialog from "../../components/topBar/TopBarDialog";

const useStyles = makeStyles((theme:Theme) => ({
    btnBase:{
        margin:theme.spacing(1),
        //width: "100%",
        display: "block",
    },
    root: {
        //margin:theme.spacing(2),
        padding:theme.spacing(2)
    },
    name:{
        whiteSpace: "nowrap",
    },
    tRow:{
        cursor: "pointer",
        "& .estado":{
            fontSize: ".9em"
        },
        ...estadoPrestamo(theme),
    },
}));
let initialState:IPrestamoFilter={
    name:"",
    rutaId: undefined,
    cajaId:undefined,
    clienteId:undefined,
    estado: undefined,
    situacion: undefined,
    fechaDesde: "",
    fechaHasta: "",
    fechaProximoPago:"",
    usuarioIdAgente:undefined,
    creadoPor:undefined,
    page: 1,
    pageSize: 15,
    orderBy: "",
    orderByIsDescending:undefined,
    ciclosPago:undefined
};
function Prestamos(){

    let navigate = useNavigate();
    let {pathname} = useLocation();
    let dispatch = useAppDispatch();
    let {list,error, status,filtered} = useAppSelector(state => state.prestamos);
    let {viewTableList} = useAppSelector(state => state.theme);
    const [selected] = useState<ICliente[]>([]);
//setSelected


    const {clienteId} = useParams();
   // initialState = clienteId ? {...initialState,clienteId: parseInt(clienteId),estado:0} : {...initialState,clienteId:undefined,estado:1}; //ver los cancelados de un cliente

    const classes = useStyles();
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState(initialState);
    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    const isEmpty = (!list?.items || list.items.length === 0);

    useEffect(() => {
        dispatch(mostrarPrestamos(clienteId ? {clienteId:+clienteId,estado:-1} : undefined)); //ver los cancelados de un cliente
        //remove filter on unmount
        return ()=> {
            if(clienteId) dispatch(mostrarPrestamos(initialState));
        }
    }, [dispatch,clienteId]);
    //set filtered params
    useEffect(()=>setFilter({...initialState,...filtered}),[setFilter,filtered])

    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        if(name === "name" || name === "page" || name === "pageSize"){
            return dispatch(mostrarPrestamos({...filter,page:1,[name]:value}));
        }
        setFilter({...filter,page:1,[name]:value})
    };
    const resetFilter = () => {
        setOpenFilter(false);
        dispatch(mostrarPrestamos(clienteId ? {clienteId:parseInt(clienteId),estado:1} : {}));
    };
    const searchFilter = () => {
        setOpenFilter(false);
        dispatch(mostrarPrestamos(filter));
    };
    const tableSortProps = (orderBy:string) => {
        return {
            active:filter.orderBy === orderBy,
            direction: filter.orderByIsDescending ? "desc" : 'asc',
            onClick:()=> dispatch(mostrarPrestamos({...filter, page:1,orderBy, orderByIsDescending: !filter.orderByIsDescending}))
        }
    };

    // const handleSelected = (e:React.ChangeEvent<HTMLInputElement>, item: IPrestamoDetalle) => {
    //     const {name, checked} = e.target;
    //     let thisRow = {
    //         id: item!.id,
    //         nombres: item!.cliente,
    //         celular: item!.clienteCelular,
    //         email: item!.clienteEmail
    //     };
    //
    //         if (checked) {
    //             setSelected(prevState => [...prevState, thisRow])
    //         }else{
    //             setSelected(prevState => prevState.filter(item => item.id !== +name))
    //         }
    // }
    return (
      <>
          <AppBar />

          <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} maxWidth={"xs"}>
              <TopBarDialog title={Strings.filtrar} onClose={()=>setOpenFilter(false)} light/>

              <DialogContent>
                  <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                          <TextField
                              label={Strings.fechaDesde}
                              type="date"
                              value={filter.fechaDesde}
                              onChange={handleFilter}
                              name="fechaDesde"
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                          <TextField
                              label={Strings.fechaHasta}
                              type="date"
                              value={filter.fechaHasta}
                              onChange={handleFilter}
                              name="fechaHasta"
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                          <TextField
                              label={Strings.proximo+" "+Strings.pago}
                              type="date"
                              value={filter.fechaProximoPago}
                              onChange={handleFilter}
                              name="fechaProximoPago"
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                          <SelectEnum
                              label={Strings.modalidad}
                              group="ciclosPago"
                              name= 'ciclosPago'
                              all
                              value={filter.ciclosPago}
                              onChange={handleFilter}
                          />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                          <SelectAgente
                              all
                              label={Strings.creadoPor}
                              value={filter.creadoPor}
                              onChange={handleFilter}
                              name="creadoPor"
                          />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                          <SelectAgente
                              all
                              label={Strings.agentes}
                              value={filter.usuarioIdAgente}
                              onChange={handleFilter}
                              name="usuarioIdAgente"
                          />
                      </Grid>

                      <Grid item xs={12} sm={filter.estado === ESTADO_PRESTAMO.ACTIVO ? 6 : 12}>
                          <SelectEnum
                              label={Strings.estado}
                              group="estadosPrestamo"
                              name= 'estado'
                              all
                              value={filter.estado}
                              onChange={handleFilter}
                          />
                      </Grid>
                      {filter.estado === ESTADO_PRESTAMO.ACTIVO &&
                          <Grid item xs={12} sm={6}>
                              <SelectEnum
                                  label={`...`}
                                  group="situacionesPrestamo"
                                  name='situacion'
                                  all
                                  value={filter.situacion}
                                  onChange={handleFilter}
                              />
                          </Grid>
                      }
                      <Grid item xs={12}>
                          <SelectRuta
                              label={Strings.ruta}
                              name= 'rutaId'
                              value={filter.rutaId}
                              all
                              onChange={handleFilter}
                          />
                      </Grid>
                      <Grid item xs={12}>
                          <SelectCartera
                              value={filter.carteraId}
                              name={"carteraId"}
                              label={Strings.cartera}
                              all
                              onChange={handleFilter}
                          />
                      </Grid>
                      <Grid item xs={12}>
                          <SelectCaja
                              value={filter.cajaId}
                              name={"cajaId"}
                              label={Strings.caja}
                              all
                              onChange={handleFilter}
                          />
                      </Grid>




                  </Grid>
                  <br/>
              </DialogContent>
              <DialogActions>
                  <Button onClick={resetFilter} color={"warning"} size={"small"} sx={{textTransform:"capitalize"}}>
                      {Strings.restablecer}
                  </Button>
                  <Button color="primary" onClick={searchFilter} variant={"outlined"}>{Strings.filtrar}</Button>
              </DialogActions>
          </Dialog>

          <section className="contentInner" style={status === "loading"?{opacity:.8}:{opacity:1}}>
              {status === "loading" && <LoadingProgress vh/>}
              {error && <MostrarError errors={error}/>}



              <ListViewMode pageRows={selected.length ?? list?.pageSize} pageTotalRows={list?.totalCount}>
                  {selected.length ?(
                      <Button disableElevation color={"secondary"} variant={"contained"} onClick={()=>navigate(pathname, {state: {contactar:selected}})}>{Strings.contactar+" "+Strings.clientes}</Button>
                  ):(<>
                      <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter}/>
                      <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(true)}/>
                      <ButtonSelect smIcon={<CloudDownloadOutlined/>} text={Strings.exportar} disabled={isEmpty}
                                    opcions={[
                                        {key:"",value:Strings.exportar +":",disabled:true},
                                        {key:"1",value:Strings.soloPrestamos},
                                        {key:"2",value:Strings.incluirPagos},
                                        {key:"3",value:"Data Crédito"}
                                    ]}
                                    onChange={(v)=>downloadFiles(filter,"prestamos",v)}
                      />

                      <FilteredAlert onClose={resetFilter} filter={filtered}/>
                  </>)}
              </ListViewMode>

            {(!viewTableList && smVewport)?(
                list?.items?.map((pre, index) =>
                    <ItemPrestamo
                        key={pre.id}
                        timeout={+(index+"000") / 3}
                        onClick={()=>navigate(`/prestamo/${pre.id}`)} item={pre}/>
                )
            ):(
                <TableSort data={[
                    // {pro:"",text:""},

                    {pro:"cliente",text:Strings.prestatarios},
                    {pro:"referencia",text:Strings.referencia},

                    {pro:"balancePendiente",text:Strings.balance+" "+Strings.pendiente, align: "right"},
                    {pro:"montoCuota",text:Strings.monto+" "+Strings.cuota, align: "right"},
                    {pro:"mora",text:Strings.mora, align: "right"},
                    {pro:"fechaProximoPago",text:Strings.proximo+" "+Strings.pago},
                    {pro:"capitalActual",text:Strings.capitalPendiente, align: "right"},
                    {pro:"gastosLegales",text:Strings.gastosLegales, align: "right"},

                    {pro:"preTipoAmortizacion",text:Strings.amortizacion},
                    {pro:"prePlazo",text:"# "+Strings.cuota},
                    {pro:"capitalInicial",text:Strings.capitalInicial, align: "right"},
                    {pro:"totalPagos",text:Strings.totalPagado, align: "right"},

                    {pro:"tasaInteres",text:Strings.interes},
                    {pro:"preCiclosPago",text:Strings.modalidad},

                    {pro:"fecha",text:Strings.fecha+" "+Strings.prestamo},
                    {pro:"cajaId",text:Strings.caja},
                    {pro:"carteraId",text:Strings.cartera},

                ]} onSort={tableSortProps} lessVh={144}>
                    <TableBody>
                        {list?.items?.map(pre =>
                                <TableRow key={pre.id} className={classes.tRow +" estado"+pre.estado+" situacion"+pre.situacion} onClick={()=>navigate(`/prestamo/${pre.id}`)}
                                          onContextMenu={(e)=>{e.preventDefault();window.open(`/prestamo/${pre.id}`,"_blank")}}>
                                    {/*<TableCell padding="checkbox" onClick={e=>e.stopPropagation()}>*/}
                                    {/*    <Checkbox name={pre.id?.toString()}  onChange={(e)=>handleSelected(e,pre)} checked={selected.some(item => item.id === pre.id)} />*/}
                                    {/*</TableCell>*/}

                                    <TableCell className={classes.name}>
                                        {pre.cliente}
                                        <div className="estado">
                                            {pre.estado === ESTADO_PRESTAMO.ACTIVO ? (
                                                <>{getValueString(SITUACION_PRESTAMO, pre.situacion)}</>
                                            ):(
                                                <>{getValueString(ESTADO_PRESTAMO, pre.estado)}</>
                                            )}

                                            {(pre.estado === ESTADO_PRESTAMO.ACTIVO && pre.situacion === SITUACION_PRESTAMO.CUOTAS_VENCIDA) && ": "+pre.cuotasAtrasadas}
                                        </div>
                                    </TableCell>
                                    <TableCell>{pre.referencia}</TableCell>

                                    <TableCell align={"right"}>{formatPeso(pre.balancePendiente)}</TableCell>
                                    <TableCell align={"right"}>{formatPeso(pre.montoCuota)}</TableCell>
                                    <TableCell align={"right"}>{formatPeso(pre.mora ?? 0) }</TableCell>

                                    <TableCell>{formatDate(pre.fechaProximoPago,"dd, DD/MM/YYYY")}</TableCell>
                                    <TableCell align={"right"}>{formatPeso(pre.capitalActual)}</TableCell>

                                    <TableCell align={"right"}>{formatPeso(pre.gastosLegales)}</TableCell>


                                    <TableCell>{translateText(pre.tipoAmortizacionString)}</TableCell>
                                    <TableCell>{pre.plazoString}</TableCell>
                                    <TableCell align={"right"}>{formatPeso(pre.capitalInicial)}</TableCell>
                                    <TableCell align={"right"}>{formatPeso(pre.totalPagos)}</TableCell>

                                    <TableCell>{pre.tasaInteres ?? 0} %</TableCell>
                                    <TableCell>{translateText(pre.ciclosPagoString)}</TableCell>
                                    <TableCell>{formatDate(pre.fecha)}</TableCell>
                                    <TableCell>{pre.caja}</TableCell>
                                    <TableCell>{pre.cartera}</TableCell>

                                </TableRow>
                        )}
                    </TableBody>
                    {!!list?.footer &&
                        <TableFooter>
                            <TableRow >
                                <TableCell colSpan={2}  align={"right"}><Typography align={"right"}>Total:</Typography> </TableCell>

                                <TableCell align={"right"}>{formatPeso(list.footer.balancePendiente)}</TableCell>
                                <TableCell align={"right"}>{formatPeso(list.footer.montoCuota)}</TableCell>
                                <TableCell align={"right"}>{formatPeso(list.footer.mora)}</TableCell>

                                <TableCell />
                                <TableCell align={"right"}>{formatPeso(list.footer.capitalActual)}</TableCell>
                                <TableCell align={"right"}>{formatPeso(list.footer.gastosLegales)}</TableCell>
                                <TableCell colSpan={2}/>
                                <TableCell align={"right"}>{formatPeso(list.footer.capitalInicial)}</TableCell>
                                <TableCell align={"right"}>{formatPeso(list.footer.totalPagos)}</TableCell>
                            </TableRow>
                        </TableFooter>}
                </TableSort>
            ) }
              {!!list &&
                  <Pagination
                      empty={Boolean(isEmpty && status !== "loading")}
                      count={list.totalCount || 0}
                      page={list.pageNumber - 1}
                      rowsPerPage={filter.pageSize??15}
                      onPageChange={(e, page) => {
                         dispatch(mostrarPrestamos({...filter,page:page + 1}));
                      }}
                      onRowsPerPageChange={handleFilter}
                  />
              }
        </section>
          {hasPermissionTo(PERSMISOS.prestamosCrear) &&
            <PlusFab component={Link} to={"/crear/prestamo"} />
          }
      </>
    );
}

export default Prestamos;



